module.exports = __webpack_public_path__ + "img/menu_24px.98987508.svg";